import { inject, provide, reactive, toRefs, Ref } from 'vue'
import { AdBannerItem } from '@/types/AdBanner'
import { getAdBanners } from '@/repositories/appApiRepository'
import { pickRandomItemsFrom } from '@/utils/adBannersUtils'

interface AdBannersState {
  banners: AdBannerItem[]
}

type UseAdBanners = {
  banners: Ref<AdBannerItem[]>
  loadAdBanners: ({ optId }: { optId: number }) => Promise<void>
  getRandomAdBanners: (size: number) => AdBannerItem[]
}

export const createAdBannersProvider = (): UseAdBanners => {
  const state = reactive<AdBannersState>({
    banners: []
  })

  const loadAdBanners = async ({ optId }: { optId: number }) => {
    const result = await getAdBanners(optId)
    state.banners = [...result.data]
  }

  const getRandomAdBanners = (size: number) => {
    return pickRandomItemsFrom(state.banners, size)
  }

  return {
    ...toRefs(state),
    loadAdBanners,
    getRandomAdBanners
  }
}

export const key = Symbol()
export const provideAdBanners = () => provide(key, createAdBannersProvider())
export const useAdBanners = () => inject(key) as UseAdBanners
